import { createSelector } from 'reselect'

export const selectCreatedTeam = createSelector(
  [state => state.teamOnboarding.createdTeam],
  createdTeam => createdTeam,
)

export const selectErrorTeamDomain = createSelector(
  [state => state.teamOnboarding.errorSettingNextStep],
  errorPayload => {
    if (!errorPayload) {
      return undefined
    }

    if (errorPayload.status === 400 && errorPayload.message.includes('already exists')) {
      return 'This team name has already been taken. Please try another one.'
    }

    if (errorPayload.status === 409 && errorPayload.message.includes('already a member')) {
      return errorPayload.message
    }

    return 'Sorry, there was a problem creating a team. Please try again or contact support.'
  },
)
